import { render, staticRenderFns } from "./addBoDefaultDomain.vue?vue&type=template&id=d20b7602&lang=pug"
import script from "./addBoDefaultDomain.vue?vue&type=script&lang=js"
export * from "./addBoDefaultDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports